export default __webpack_public_path__ + "static/Data-Monetization-29f7e67da9276b06e7030b6bb0fb2f81.webp";